<template>
  <div class="fadein">
    <div class="h30"></div>
    <!-- temp-4 start-->
    <transition name="el-zoom-in-center">
      <div class="center1200 temp-2" v-if="hot_forum">
        <div>
          <!-- 活跃论坛 Start -->
          <div class="hot-forum shadow">
            <div class="center-title">
              <a href="#"
                ><img
                  class="title-pic"
                  src="/static/img/title-left.png"
                  alt=""/>
                活跃论坛
                <img class="title-pic" src="/static/img/title-right.png" alt=""
              /></a>
            </div>
            <div class="h20"></div>
            <ul>
              <li v-for="(v, k) in hot_forum">
                <a href="javascript:;" @click="goForumDetail(v.id)"
                  ><img :src="getTopImg(k + 1)" alt="" class="top5" />{{
                    v.title
                  }}</a
                >
                <div class="gray">
                  <i class="el-icon-view"></i> {{ v.reviews_count }}
                </div>
              </li>
            </ul>
          </div>
          <!-- 活跃论坛 End -->
          <div class="h20"></div>
          <!-- 今日话题 Start -->
          <div class="hot-forum shadow">
            <div class="center-title" style="position:relative;">
              <a href="#"
                ><img
                  class="title-pic"
                  src="/static/img/title-left.png"
                  alt=""/>
                今日话题
                <img class="title-pic" src="/static/img/title-right.png" alt=""
              /></a>
              <el-tooltip
                class="item"
                effect="dark"
                content="发布话题"
                placement="top"
              >
                <router-link
                  to="/createtopic"
                  class="create-forum"
                  style="right:0px;"
                  ><span
                    class="el-icon-circle-plus-outline"
                    style="font-size:30px;"
                  ></span
                ></router-link>
              </el-tooltip>
            </div>
            <div class="h20"></div>
            <ul>
              <li v-for="(v, k) in all_topics">
                <a href="javascript:;" @click="goTopicDetail(v.id)">{{
                  v.title
                }}</a>
                <div class="gray">
                  <i class="el-icon-view"></i> {{ v.reviews_count }}
                </div>
              </li>
            </ul>
          </div>
          <!-- 今日话题 End -->
          <div class="h20"></div>
          <!-- 用户推荐 Start -->
          <div
            class="user-recommend shadow"
            style="padding:0 10px;width:350px;"
          >
            <div class="h20"></div>
            <div class="center-title">
              <a href="#"
                ><img
                  class="title-pic"
                  src="/static/img/title-left.png"
                  alt=""/>
                用户推荐
                <img class="title-pic" src="/static/img/title-right.png" alt=""
              /></a>
            </div>
            <div class="h20"></div>
            <ul>
              <li v-for="v in rec_users">
                <div>
                  <img
                    :src="v.extras.user_pic"
                    alt=""
                    class="rec-head"
                    v-if="v.extras.user_pic != 'http://' + $API_URL"
                    @click="goUserinfo(v.id)"
                  /><img
                    src="/static/img/default_userpic.png"
                    alt=""
                    class="rec-head"
                    v-else
                    @click="goUserinfo(v.id)"
                  />
                </div>

                <p>
                  <span
                    v-if="v.extras.nickname != null"
                    @click="goUserinfo(v.id)"
                    >{{ v.extras.nickname }}</span
                  ><span v-else @click="goUserinfo(v.id)">{{ v.mobile }}</span>
                </p>
              </li>
            </ul>
          </div>
          <!-- 用户推荐 End -->
        </div>

        <div class="bg-white shadow" style="width:810px;">
          <div class="h20"></div>

          <div class="center-title" style="position:relative;">
            <a href="#"
              ><img class="title-pic" src="/static/img/title-left.png" alt=""/>
              最新论坛
              <img class="title-pic" src="/static/img/title-right.png" alt=""
            /></a>
            <el-tooltip
              class="item"
              effect="dark"
              content="发布文章"
              placement="top"
            >
              <router-link to="/createforum" class="create-forum"
                ><span
                  class="el-icon-circle-plus-outline"
                  style="font-size:30px;"
                ></span
              ></router-link>
            </el-tooltip>
          </div>
          <div class="h20"></div>
          <div class="padding20" style="padding-top:0;">
            <ul>
              <li class="forum-box" v-for="v in forums">
                <div class="forum-title" @click="goForumDetail(v.id)">
                  {{ v.title }}
                </div>
                <div class="forum-content">{{ v.desn }}</div>
                <div class="forum-bottom">
                  <div>
                    <img
                      :src="v.user_info.extras.user_pic"
                      alt=""
                      class="author-pic"
                      v-if="v.user_info.extras.user_pic != 'http://' + $API_URL"
                      @click="goUserinfo(v.user_info.extras.user_id)"
                    />
                    <img
                      src="/static/img/default_userpic.png"
                      alt=""
                      class="author-pic"
                      v-else
                      @click="goUserinfo(v.user_info.extras.user_id)"
                    />
                    <!-- <span ></span> -->
                  </div>
                  <div class="author-name">
                    <span
                      v-if="v.user_info.extras.nickname != null"
                      @click="goUserinfo(v.user_info.extras.user_id)"
                      >{{ v.user_info.extras.nickname }}</span
                    >
                    <span
                      v-else
                      @click="goUserinfo(v.user_info.extras.user_id)"
                      >{{ v.user_info.mobile }}</span
                    >
                  </div>
                  <div class="forum-info">
                    <div class="forum-info-son">浏览:{{ v.reviews_count }}</div>
                    <!-- <div class="forum-info-son">有用:{{v.useful_count}}</div> -->
                    <!-- <div class="forum-info-son">没用:{{v.useless_count}}</div> -->
                    <div class="forum-info-son">收藏:{{ v.fav_count }}</div>
                  </div>
                  <div class="forum-pubdate">
                    <!-- <div class="forum-pubdate-son">举报</div> -->
                    <div class="forum-pubdate-son">{{ v.created_at }}</div>
                  </div>
                </div>

                <div style="clear: both;"></div>
                <el-divider></el-divider>
              </li>
            </ul>
            <div style="text-align: center;">
              <el-pagination
                layout="prev, pager, next"
                :total="total"
                :page-size="pagesize"
                :current-page="page"
                @current-change="currentChange"
                hide-on-single-page
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- temp-4 end-->

    <div class="h30"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //推荐用户
      rec_users: [],
      //所有论坛
      forums: [],
      //当前页码
      page: 1,
      //文章列表（12条）
      pagesize: 12,
      //文章总条数
      total: 0,

      //活跃论坛
      hot_forum: [],
      //全部话题
      all_topics: []
    };
  },
  watch: {
    $route(newVal, oldVal) {
      this.forums = {};
      this.hot_forum = {};
      //路由改变时触发电影id的改变
      if (newVal.name == "forum") {
        this.$parent.activeIndex = "4";
        //
        this.getAllForum();
        this.getAllTopics();
        this.getHotForum();
      }
    }
  },
  mounted() {
    this.getRecUsers();
    this.getAllForum();
    this.getAllTopics();
    this.getHotForum();
  },
  methods: {
    //获取推荐用户
    getRecUsers() {
      if (localStorage.getItem("token")) {
        $.ajax({
          url: "//" + this.$API_URL + "/api/v1/users/recommend",
          type: "post",
          data: { user_id: this.token },
          success: ret => {
            this.rec_users = ret.data;
          }
        });
      } else {
        $.ajax({
          url: "//"+ this.$API_URL +"/api/v1/users/recommend",
          type: "post",
          success: ret => {
            this.rec_users = ret.data;
          }
        });
      }
    },
    //获取全部论坛（根据时间）
    getAllForum() {
      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/articles",
        type: "get",
        data: { page: this.page },
        success: ret => {
          if (ret.code == 200) {
            this.forums = ret.data.data;
            this.total = ret.data.total;
          }
        }
      });
    },
    //跳转到论坛详情
    goForumDetail(fid) {
      this.$router.push("/forumdetail/" + fid).catch(err => {
        err;
      });
    },
    //点击用户名或头像跳转到用户信息页
    goUserinfo(uid) {
      this.$router.push("/user/" + uid).catch(err => {
        err;
      });
    },
    //获取活跃论坛
    getHotForum() {
      $.ajax({
        url: "//"+ this.$API_URL +"/api/v1/articles/get_hot_articles",
        type: "get",
        success: ret => {
          this.hot_forum = ret.data;
        }
      });
    },
    //获取全部话题
    getAllTopics(page = 1) {
      $.ajax({
        url: "//" + this.$API_URL + "/api/v1/votes",
        type: "get",
        data: { topics_page: page },
        success: ret => {
          this.all_topics = ret.data.data;
        }
      });
    },
    //跳转到话题详情
    goTopicDetail(tid) {
      this.$router.push("/topicdetail/" + tid).catch(err => {
        err;
      });
    },

    getTopImg(k) {
      return "/static/img/top/" + k + ".png";
    },
    //分页跳转
    currentChange(val) {
      this.page = val;
      //
      this.getAllForum();
    }
  }
};
</script>

<style scoped>
.top5 {
  vertical-align: middle;
  margin-right: 5px;
}
.hot-forum {
  /* float:right; */
  background: #fff;
  width: 320px;
  /* height: 750px; */
  padding: 25px 25px 10px 25px;
}
.hot-forum ul {
  list-style: none;
  color: #4a4b4d;
}
.hot-forum ul li {
  height: 60px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #ddd;
}
.hot-forum ul li:last-child {
  border-bottom: none;
}
.hot-forum ul li a {
  text-decoration: none;
  color: #3c3c3b;
  transition: 0.25s;
}
.hot-forum ul li a:hover {
  color: #ff7400;
  transition: 0.25s;
}
.forum-title {
  cursor: pointer;
  transition: 0.25s;
  padding-left: 20px;
  font-size: 20px;
  width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.forum-title:hover {
  transition: 0.25s;
  color: #ff7400;
}
.forum-content {
  padding-left: 20px;

  font-size: 16px;
  width: 730px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999;
}
.forum-box {
  list-style: none;
  margin-bottom: 30px;
}
.author-pic {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.author-pic {
  float: left;
  margin-top: 10px;
  margin-left: 20px;
}
.author-name {
  transition: 0.25s;
  margin-left: 10px;
  float: left;
  line-height: 60px;
}
.author-name:hover {
  transition: 0.25s;

  color: #ff7400;
  cursor: pointer;
}
.forum-info {
  margin-left: 20px;
  float: left;
}
.forum-info-son {
  float: left;
  line-height: 60px;
  margin-left: 20px;
  color: #666;
}
.forum-pubdate {
  float: right;
  padding-right: 20px;
  line-height: 60px;
}
.forum-pubdate-son {
  font-size: 14px;
  float: left;
  margin-left: 20px;
  color: #999;
}
.temp-2 {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
}

.user-recommend {
  float: right;
  width: 320px;

  background: #fff;
  padding: 25px 25px 10px 25px;
}
.user-recommend ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}
.user-recommend ul li {
  text-align: center;
  list-style: none;
  margin-bottom: 20px;
  text-align: center;
  width: 105px;
}
.user-recommend ul li div {
  margin: 0 auto;
  width: 85px;
  height: 85px;
  border-radius: 50%;
  border: 1px solid #fff;
  transition: 0.5s;
}
.user-recommend ul li p {
  margin: 0 auto;
  text-align: center;
  /* width:107px; */
  font-weight: 500;
  line-height: 20px;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  color: #300133;
  /* width:85px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-recommend ul li:hover p {
  transition: 0.5s;
  color: #ff7400;
  /* border:1px solid #ff7400; */
}
.user-recommend ul li:hover div {
  border: 1px solid #ff7400;
}
.rec-head {
  cursor: pointer;

  width: 85px;
  height: 85px;
  border-radius: 50%;
  /* border:1px solid #fff; */
}

.create-forum {
  cursor: pointer;
  position: absolute;
  right: 30px;
}
/* elementui样式 */
.el-icon-circle-plus-outline {
  transition: 1s;
}
.el-icon-circle-plus-outline:hover {
  transition: 0.25s;
  color: #ff7400;
}
</style>



// WEBPACK FOOTER //
// src/components/index/forum.vue